module Shared.Dto.RimPro

open System

type StationDto = {
    Id: Guid
    Name: string
    AirSensorId: int
    RainSensorId: int
    FirstLeafletWetnessSensorId: int
    SecondLeafletWetnessSensorId: int option
}

type NewRimProStationDto = {
    Name: string
    AirSensorId: int
    RainSensorId: int
    FirstWetnessSensorId: int
    SecondWetnessSensorId: int option
}

type SelectableSensor = {
    Id: int
    Name: string
}

type SelectableSensors = {
    MySensors: SelectableSensor list
    GroupSensors: SelectableSensor list
}

[<RequireQualifiedAccess>]
module SelectableSensors =
    let tryHead (sensors: SelectableSensors) : SelectableSensor option =
        let firstUserSensor = List.tryHead sensors.MySensors

        match firstUserSensor with
        | Some sensor -> Some sensor
        | None -> List.tryHead sensors.GroupSensors

    let tryFind (id: int) (sensors: SelectableSensors) : SelectableSensor option =
        let predicate = (fun sensor -> sensor.Id = id)
        let maybeUserSensor = List.tryFind predicate sensors.MySensors

        match maybeUserSensor with
        | Some sensor -> Some sensor
        | None -> List.tryFind predicate sensors.GroupSensors

    let sort (sensors: SelectableSensors) : SelectableSensors = {
        MySensors = List.sortBy (fun x -> x.Name) sensors.MySensors
        GroupSensors = List.sortBy (fun x -> x.Name) sensors.GroupSensors
    }

type SensorsResponseDto = {
    AirSensors: SelectableSensors
    RainSensors: SelectableSensors
    LeafletWetnessSensors: SelectableSensors
}

[<RequireQualifiedAccess>]
module SensorsResponseDto =
    let empty = {
        AirSensors = {
            MySensors = []
            GroupSensors = []
        }
        RainSensors = {
            MySensors = []
            GroupSensors = []
        }
        LeafletWetnessSensors = {
            MySensors = []
            GroupSensors = []
        }
    }

    let sort (dto: SensorsResponseDto) : SensorsResponseDto = {
        AirSensors = SelectableSensors.sort dto.AirSensors
        RainSensors = SelectableSensors.sort dto.RainSensors
        LeafletWetnessSensors = SelectableSensors.sort dto.LeafletWetnessSensors
    }

type RimProIframeOwnerDto =
    | User
    | Group of groupName: string

type RimProIframeDto = {
    RimProId: string
    Owner: RimProIframeOwnerDto
}